import apiRoutes from "welcome/apiRoutes";
import { createActionFetcher } from "shared/redux-store/defaults";

export const fetchWelcomeStatistics = createActionFetcher(
  "WELCOME_STATISTICS",
  [apiRoutes.platformStatisticsPath()],
);
